import { SelectOption } from './types';

export const flattenArr = (arr: SelectOption[]) => {
  let result: SelectOption[] = [];

  for (const item of arr) {
    if (item.children) {
      result.push(...flattenArr(item.children));
    } else {
      result.push(item);
    }
  }

  return result;
};
